export default __webpack_public_path__ + "static/media/rm_icon.167a6d92.svg";